import React, { PropTypes } from 'react';
import { Provider } from 'react-redux';
import DevTools from './DevTools';
import { Router } from 'react-router';
import routes from '../routes';

const propTypes = {
  history: PropTypes.object.isRequired,
  store: PropTypes.object.isRequired,
};

function Root({ store, history }) {
  return (
    <div>
      <Provider store={store}>
        <div>
          <Router history={history} routes={routes} />
          <DevTools />
        </div>
      </Provider>
    </div>
  );
}

Root.propTypes = propTypes;

export default Root;



// WEBPACK FOOTER //
// ./src/containers/Root.dev.js